if not App.angularApp?
    return

App.angularApp.directive 'mfUibBtnRadioYesNo', ->
    require: 'ngModel'
    restrict: 'AE'
    # using a function for the template allows us to create dynamic HTML
    template: (element, attrs) ->
        buttonAttrs = "ng-model='#{attrs.ngModel}'"
        if attrs.ngDisabled?
            buttonAttrs += " ng-disabled='#{attrs.ngDisabled}'"
        if attrs.uncheckable?
            buttonAttrs += " uncheckable"
        if attrs.classes?
            classes = attrs.classes
        return """
            <div class='btn-group #{classes}'>
                <button type='button'
                    class='btn btn-group-split'
                    ng-class='{ "btn-primary": (#{attrs.ngModel}) === true }'
                    uib-btn-radio='true'
                    #{buttonAttrs}
                >
                    Yes
                </button>
                <button type='button'
                    class='btn btn-group-split'
                    ng-class='{ "btn-danger": (#{attrs.ngModel}) === false }'
                    uib-btn-radio='false'
                    #{buttonAttrs}
                >
                    No
                </button>
            </div>
        """
    replace: true
    link: (scope, ele, attrs, ngModelCtrl) ->
        return
